import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateBookAuthorModal, EditBookAuthorModal, BookAuthorsListFilters } from "@modules/bookAuthors/components";

import { useBookAuthors } from "./controller";
import { useBookAuthorsListColumns } from "./columns";

export const BookAuthorsList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    books,
    selectedRows,
    dataToExport,
    createBookAuthorModalRef,
    editBookAuthorModalRef,
    setSelectedRows,
    refetch,
    translate,
  } = useBookAuthors();

  const columns = useBookAuthorsListColumns(refetch, translate, editBookAuthorModalRef, books);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <BookAuthorsListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="book-activities.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createBookAuthorModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateBookAuthorModal
        modalRef={createBookAuthorModalRef}
        onComplete={refetch}
      />
      
      <EditBookAuthorModal
        modalRef={editBookAuthorModalRef}
        onComplete={refetch}
      />
    </List>
  );
});
